import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { RolesSharedService } from "@app/feature/main/roles-shared/services/roles-shared.service";
import { MixpanelEventLoggingService } from "@shared/services/mixpanel-event-logging.service";
import { CheckoutModalComponent } from "@app/feature/main/roles-shared/components/checkout-modal/checkout-modal.component";
declare const $: any;
import swal from "sweetalert2";
import { ResponseContentType, Http } from "@angular/http";
import { AccessToken } from "@app/util/accessToken";
import { AuthenticationService } from "@app/shared/services/authentication.service";
import { NickNameModalService } from "@app/feature/main/roles-shared/services/nick-name-modal.service";
import { CommentModalService } from "@app/shared/services/comment-modal.service";
import { LikeModalServiceService } from "@app/shared/services/like-modal-service.service";
import { MarketDataDetailsService } from "@app/feature/main/roles-shared/services/market-data-details.service";
import { BreadcrumService } from "@app/shared/services/breadcrum.service";
import { Meta, Title } from '@angular/platform-browser';
declare var window: any;
@Component({
  selector: "app-report-details",
  templateUrl: "./report-details.component.html",
  styleUrls: ["./report-details.component.css"]
})
export class ReportDetailsComponent implements OnInit {
  @ViewChild(CheckoutModalComponent) checkoutModalDetails: CheckoutModalComponent;
  reportId = "2e1b69b0-3664-4ec2-ba89-61677384024c"; //2e1b69b0-3664-4ec2-ba89-61677384024c  f6604842-0c43-4146-b615-36ed40231f03
  report;
  userDetailsObject: any;
  userId;
  userRole: string;
  myRating = 0;
  currentView = "summary";
  shareUrl: string;
  loggedInStatus;
  entityType: string;
  htmlContent =
    ' <h2>																	<strong class="ql-size-huge">Report Title</strong></h2><p><br></p><p><br></p><p><a href="https://projects.invisionapp.com/" target="_blank">Lorem ipsum </a>dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc,</p><p><br></p><h3><strong>Lorem ipsum</strong></h3><p><br></p><p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc,</p><p><br></p><h3><strong>Lorem ipsum</strong></h3><p><br></p><p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc,</p><p><br></p><table><tbody><tr><td data-row="row-5ed5">No</td><td data-row="row-5ed5">Name</td><td data-row="row-5ed5">Age</td><td data-row="row-5ed5">Occupation</td></tr><tr><td data-row="row-ec4a">1</td><td data-row="row-ec4a">ABC</td><td data-row="row-ec4a">30</td><td data-row="row-ec4a">SE</td></tr><tr><td data-row="row-lq7u">2</td><td data-row="row-lq7u">ABC</td><td data-row="row-lq7u">30</td><td data-row="row-lq7u">SE</td></tr><tr><td data-row="row-vt7l">3</td><td data-row="row-vt7l">ABC</td><td data-row="row-vt7l">30</td><td data-row="row-vt7l">SE</td></tr></tbody></table><p><br></p><p><img src="https://ecosystem-uploads.s3.ap-southeast-1.amazonaws.com/7661e062-a7b9-42ea-8137-ac92f48ae61d"></p><p><br></p><ol><li data-list="ordered">A</li><li data-list="ordered">B</li><li data-list="ordered">C</li><li data-list="ordered">D</li></ol><p><br></p><p><br></p>';
  load: boolean;
  showView: boolean;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private rolesSharedService: RolesSharedService,
    private mixpanelEventLoggingService: MixpanelEventLoggingService,
    private http: Http,
    private accessToken: AccessToken,
    private nickNameModalService: NickNameModalService,
    private commentModalService: CommentModalService,
    private likeModalService: LikeModalServiceService,
    private authenticationService: AuthenticationService,
    private marketDataDetailsService: MarketDataDetailsService,
    private breadcrumService:BreadcrumService,
    private titleService: Title,
  ) { }

  ngOnInit() {
    this.isLoggedIn();
    this.showView = false;
    this.reportId = this.route.snapshot.paramMap.get("id");
    this.entityType = "report";
    this.getReportDetails();
    this.userDetails();
  //  window.scroll(0, 0);
  }
  routeTechAnalystProfilePage(analystId: string) {
    this.router.navigate(['analyst-profile'], { queryParams: { analystId: analystId } });
  }

  navRouteToReports() {
    this.router.navigate([`/reports`]);
  }

  navToMarketData(marketDataId, researchDocId ,  marketDataTitle) {
    const filter: any = {};
    filter.filter = JSON.stringify({
      include: [
        { survey: { responses: "users" } },
        "domain",
        "geographies",
        "countries",
      ]
    });
    filter.isHighlight = "true";
    if (this.userRole === "tech-buyer" || this.userRole === "tech-vendor") {
      this.rolesSharedService.getResearchData(filter, researchDocId).subscribe(
        (response: any) =>  {
            if (this.userRole === "tech-buyer") {
               if (!response.isParticipated) {
                 this.router.navigate([`tech-buyer/research-snapshot/${researchDocId}`]);
               } else {
                 this.redirect(marketDataId, researchDocId ,  marketDataTitle);
               }
            } else if (this.userRole === "tech-vendor") {
              if (!response.isSubscribed && !response.isPurchased) {
                 this.router.navigate([`tech-vendor/market-data/${researchDocId}`]);
               } else {
                this.redirect(marketDataId, researchDocId ,  marketDataTitle);
               }
            }
        },
        error => { }
      );
    } else {
      this.redirect(marketDataId, researchDocId ,  marketDataTitle);
    }
  }

  redirect(marketDataId, researchDocId ,  marketDataTitle){
    this.breadcrumService.setUrl('BC2Url', "reports");
    this.breadcrumService.setUrl('BC2Label', "Reports");
    this.breadcrumService.setUrl('BC3Label', this.report.title);
    if (this.userRole === "tech-analyst" || this.userRole === "tech_analyst") {
      this.breadcrumService.setUrl('BC3Url', `${this.userRole}/reports/report-details/${this.report.id}`);
    } else {
      this.breadcrumService.setUrl('BC3Url', `${this.userRole}/report-details/${this.report.id}`);
    }
    sessionStorage.setItem('BC4Label', marketDataTitle);
    sessionStorage.setItem("fromReports" , "true" );
    this.router.navigate([`${this.userRole}/market-data-details/${researchDocId}/${marketDataId}`]);
  }

  isLoggedIn() {
    if (this.authenticationService.isLoggedIn()) {
      this.loggedInStatus = true;
      this.getRole();
    } else {
      this.loggedInStatus = false;
    }
  }

  userDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      this.userId = this.userDetailsObject.userId;
    }
  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }

  getReportDetails() {
    const filter: any = {};
    filter.filter = JSON.stringify({ "include": ["bookmark", "users", "domains"] });
    this.rolesSharedService.getReportById(this.reportId, filter).subscribe(
      (response: any) => {
        this.report = response;
        this.myRating = response.myRatings ? response.myRatings.rating : 0;
        this.htmlContent = this.report.contentHTML;
        this.showView = true;

        this.titleService.setTitle('Report: ' + response.title || 'Ecosystm');
        var _hsq = window._hsq = window._hsq || [];
         _hsq.push(["trackEvent", {
          id: response.title,
          value : response.title
          }]); 
        _hsq.push(['trackPageView'])
        _hsq.push(['refreshPageHandlers']);

      },
      error => {
        if (error.status === 403) {
          this.getPaidReportDetails();
        }
      }
    );
  }

  getPaidReportDetails() {
    this.checkAlreadyPaid();
    this.rolesSharedService.getSynopsisDetails(this.reportId).subscribe(
      (rep) => {
        this.report = rep;
        this.htmlContent = this.report.contentHTML;
      },
      error => {
        swal("Info", error.error.error.message, "info");
      }
    )
  }
  viewReportDetails(data) {
    let eventName;
    if (data === "report_view") {
      eventName = "view report";
    } else if ( data === "report_download"){
      eventName = "download report";
    }

    const viewDetails = {
      reportId: this.reportId,
      activity: data
    };
    this.rolesSharedService.viewReport(viewDetails).subscribe(
      response => {
        if(this.report) {
          this.mixpanelEventLoggingService.dispatchEvent(eventName, {
            "Tech Domain": this.report.domains[0].name,
            "Report Name": this.report.title
          });
        }
      },
      error => { }
    );
  }
  showDetails() {
    if (this.report.paid && (!this.isSamePublisher) && this.isAnalyst) {
      this.report.isPurchased ? this.showDetailsView() : this.purchaseModal();
    }
    else if (!this.report.isPurchased) {
      this.purchaseModal();
    }
    else {
      this.showDetailsView();
      this.viewReportDetails('report_view');
    }
    window.scroll(0, 0);
  }
  showDetailsView() {
    this.currentView = "details-view";
    this.render();
  }

  switchView() {
    if (!this.report.myRatings) {
      $("#ratingModal").modal('show');
    }
    if (this.report.paid && (!this.isSamePublisher) && this.isAnalyst) {
      this.report.isPurchased ? this.currentView = "summary" : this.purchaseModal();
    }
    else {
      this.currentView = "summary";
    }
  }

  checkDownloadPermission(url, reportName) {
    if (this.report.paid && (!this.isSamePublisher) && this.isAnalyst) {
      this.report.isPurchased ? this.downloadPdf(url, reportName) : this.purchaseModal();
    } else if (!this.report.isPurchased) {
      this.purchaseModal();
    } else {

      this.downloadPdf(url, reportName);

    }
  }

  render() {
    const html = $.parseHTML(this.htmlContent);
    setTimeout(() => {
      $("#render-area").append(html);
    }, 50);
  }

  purchaseModal() {
    this.checkoutModalDetails.showModal(this.entityType, this.reportId);
  }
  refreshAPI() {
    this.mixpanelEventLoggingService.dispatchEvent("purchase report", {
      "Tech Domain": this.report.domains[0].name,
      "Report Name": this.report.title,
      "Price": this.report.amount,
      "Payment Mode": "Card"
    });
    this.checkoutModalDetails.hideModal();
    this.getReportDetails();
    swal("Success", 'Report purchased successfully', "success");
  }

  downloadPdf(url, reportName) {
    this.viewReportDetails('report_download');
    return this.http
      .get(url, {
        responseType: ResponseContentType.Blob
      })
      .map(res => {
        return {
          filename: `${reportName}.pdf`,
          data: res.blob()
        };
      })
      .subscribe(res => {
        var url = window.URL.createObjectURL(res.data);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = res.filename;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
        if (!this.report.myRatings) {
          setTimeout(function () {
            $("#ratingModal").modal('show');
          }, 1000);
        }

        this.titleService.setTitle('Downloaded Report: ' + res.filename || 'Ecosystm');
        var _hsq = window._hsq = window._hsq || [];
         _hsq.push(["trackEvent", {
          id: res.filename,
          value : res.filename
          }]); 
        _hsq.push(['trackPageView'])
        _hsq.push(['refreshPageHandlers']);

      }, error => {

      }, () => {

      });
  }
  isSamePublisher() {
    if (this.report.users.id === this.accessToken.getLoggedUserId()) {
      return true;
    }
    else {
      return false;
    }
  }

  bookmark(data: any, type: string) {
    const bookmarkData: any = {};
    if (data.bookmarkId) {
      bookmarkData.bookmarkId = data.bookmarkId;
    }
    bookmarkData.postId = data.id;
    bookmarkData.postType = type;
    this.rolesSharedService.bookmark(bookmarkData).subscribe(
      (response: any) => {
        this.getReportDetails();
        if (response.bookmarked) {
          data.bookmarked = true;
          swal({
            position: "center",
            type: "success",
            title: "Added to the bookmarks list",
            showConfirmButton: false,
            timer: 1000
            // text: "Bookmarked"
          });
        } else {
          data.bookmarked = false;
          swal({
            position: "center",
            type: "success",
            title: "Removed from the bookmarks list",
            showConfirmButton: false,
            timer: 1000
            // text: "Bookmarked"
          });
        }
      },
      error => { }
    );
  }

  isAnalyst() {
    const role = this.authenticationService.getRole();
    if (role === "tech_analyst") {
      return true;
    } else {
      return false;
    }
  }

  mapPostData(report: any) {
    let data: any = {};
    if (report.myRatings) {
      data = {
        id: report.myRatings.id,
        postId: report.id,
        rating: this.myRating,
        userId: this.userId,
        postType: "report"
      };
    } else {
      data = {
        postId: report.id,
        rating: this.myRating,
        userId: this.userId,
        postType: "report"
      };
    }
    return data;
  }

  submitRating(report: any) {
    if (report.myRatings) {
      this.rolesSharedService
        .rating(JSON.stringify(this.mapPostData(report)))
        .subscribe((response: any) => {
          if (response) {
            // report.myRatings = true;
            this.closeRatingModal();
            this.getReportDetails();
          }
        });
    } else {
      this.rolesSharedService
        .submitRating(JSON.stringify(this.mapPostData(report)))
        .subscribe((response: any) => {
          if (response) {
            // report.myRatings = true;
            this.closeRatingModal();
            this.getReportDetails();
          }
        });
    }

  }

  closeRatingModal() {
    $("#ratingModal").modal("hide");
  }

  likeClick(postData: any) {
    if (this.userDetailsObject.nickName) {
      const likeObject = {
        postId: postData.id,
        postType: "report",
        userId: this.userId
      };
      this.rolesSharedService.addLike(likeObject).subscribe(likeResponse => {
        if (likeResponse["liked"]) {
          // case when user is liked and updated in server
          postData.liked = true;
          postData.likes += 1;
          this.rolesSharedService.logLikeInMixpanel(likeObject.postType, postData.title);
          this.report.isLiked = !this.report.isLiked;
        } else if (!likeResponse["liked"]) {
          // case when user is not liked and updated in server
          postData.liked = false;
          if (postData.likes !== 0) {
            postData.likes -= 1;
          }
        }
      });
    } else {
      this.nickNameModalService.openNickNameModal();
      this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
        if (response) {
          this.userDetails();
        }
      });
    }
  }

  openCommentModal(data) {
    if(window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null"){
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      if (this.userDetailsObject.nickName) {
        this.commentModalService.modalStatus(true, data);
      } else {
        this.nickNameModalService.openNickNameModal();
      }
    }
  }

  populateComments(post) {
    if (this.userDetailsObject.nickName) {
      post.showComments = !post.showComments;
    } else {

      this.nickNameModalService.openNickNameModal();
      this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
        if (response) {
          this.userDetails();
        }
      });
    }
  }

  displayShareModal(researchData) {
    this.shareUrl = `${document.location.origin}/#/link?type=report&id=${researchData.id}`;
    $("#share-modal").modal("show");
  }

  closeShareModal() {
    $("#share-modal").modal("hide");
  }
  checkAlreadyPaid() {
    const isCompletedPayment = this.rolesSharedService.getPaymentState();
    if (isCompletedPayment) {
      this.rolesSharedService.setPaymentSate(false);
      this.purchaseModal();
    }
  }

  openLikeModal(data) {
    if (this.loggedInStatus) {
      this.likeModalService.modalStatus(true, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/report-details/report-details.component.ts